let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("tdXqH"), load("hTb1M"), load("jPS1u"), load("8yyrA"), load("52dqm")]).then(() => parcelRequire('3zSMJ'));